/**
 * 德州隆达空调设备集团有限公司-数据
 */
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
//德州隆达空调设备集团有限公司
const ldlb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldlb1.jpeg";
const ldlb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldlb2.jpeg";
const ldlb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldlb3.jpeg";
const ldlb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldlb4.jpeg";

const ldcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldcp1.png";
const ldcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldcp2.png";
const ldcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldcp3.png";
const ldbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldbg1.png";
const ldbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldbg2.png";
const ldbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldbg3.png";
export default {
    homeData: 	{
		herderBanner: [ldlb1, ldlb2, ldlb3, ldlb4],
		//企业logo
		logo: "https://gimg3.baidu.com/search/src=http%3A%2F%2Fgips1.baidu.com%2Fit%2Fu%3D3529100696%2C3860853830%26fm%3D3030%26app%3D3030%26f%3DJPEG%3Fw%3D121%26h%3D74%26s%3D18D2CA1296A178A147E871C6030070B0&refer=http%3A%2F%2Fwww.baidu.com&app=2021&size=f242,150&n=0&g=0n&q=100&fmt=auto?sec=1686243600&t=24028e2efe6bca383d6a68846ea0b077",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldlogo.jpg",
		isShowVrModal: true,
		isShowVr: true,
		vRurl: "https://fs.m2.com.cn/home/20467100",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `德州隆达空调设备集团有限公司最初成立于2014年，集团注册资金1.1亿，机电安装三级资质，是同行业中唯一一家上央视《诚信档案》的企业；集团是《GB/T 41318-2022国家通风消声器标准》的主要起草单位，隆达集团董事长尹志朋为标准主要起草人；主营中央空调末端及消防通风设备包括：风机、防爆风机、风阀、风口、风管、消声器等系列产品产销一体的中型企业，2021年销售额为1.57亿元。
		公司生产车间面积20000平方米，公司生产设备300多台套，流水线13条，生产机械化程度达90%以上、自动化半自动化设备占总设备的70%以上，公司生产所需要的关键部件都是自产，例如：电机、空调风机叶轮、轴流风机叶轮、传动轴等都是公司自已生产配件自已组装，从源头上保证产品的质量，实行质量三包政策，公司产品的质保期为三年。
		集团有职工260余人，专业技术人员36人，公司为同行业龙头企业，纳税前三企业，不仅市场占有率高，且技术力量雄厚、生产工艺先进、检测设备齐全、管理制度完善、产品质量可靠，拥有标性能检测实验室，荣获“山东知名品牌”、“武城县县长质量奖提名奖”、“山东省专精特新企业”，拥有二十多项国家专利；率先通过 两化融合管理体系评定证书、ISO9001质量体系认证、ISO14001环境体系认证、OHSAS18001职业健康与安全管理体系认证，并通过中国制冷空调行业CRAA认证、应急管理部消防产品合格评定中心认证，取得CCCF认证证书。公司树立以质量、效率、创新为核心的企业精神，激励隆达人锐意进取、引领行业，实现高质量发展。
		公司秉承“以顾客需求和满意为中心、注重高质量改进、追求卓越管理、依法诚信经营、提供优质服务”的理念，坚持“真诚合作、以人为本”的原则，愿与各界人士竭诚合作，共创美好未来！`,
		//公司官网
		website: "www.ldktfj.com",
		operatingStatus: "正常在业",
		//经营品类
		categories:
			"空调设备及零部件、净化设备及零部件、通风设备及零部件、风机及零部件、防火阀、排烟阀、防火排烟阀、消防排烟风机、消声器、机电设备的生产、销售、安装；镀锌风管、玻璃钢制品销售；及以上产品的进出口业务；建筑机电安装工程、人防工程施工。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
		//公司地址
		companyAddress: "山东省德州市武城县鲁权屯镇腾鲁大街北侧",
		site: "山东省德州市",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "11000万人民币",
		//成立日期
		establishment: "2014-9-30",
		//经营品牌
		brand: "圣隆达",
		//主营产品
		mainProducts:
			"空调设备及零部件、净化设备及零部件、通风设备及零部件、风机及零部件、防火阀、排烟阀、防火排烟阀、消防排烟风机、消声器、机电设备的生产、销售、安装；镀锌风管、玻璃钢制品销售；及以上产品的进出口业务；建筑机电安装工程、人防工程施工。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
		//企业名称
		headerTitle: "德州隆达空调设备集团有限公司",
		moreInfoName: "德州隆达空调设备集团有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.预付款（生产完成付尾款发货）`,
		//工厂地址
		factoryAddress: "山东省德州市武城县鲁权屯镇腾鲁大街北侧",
		//工厂人数
		factoryHeadcount: "202",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "20000平方米",
		capacity: "年生产额为1.5亿元",

		//联系负责人
		person: "尹志波 ",
		//联系电话
		contactNumber: "18888238000",
		//资质证书
		qualificationList: [
			{
				name: "安全生产许可证最新版",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz1.png",
			},
			{
				name: "环境管理体系",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz2.png",
			},
			{
				name: "两化融合",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz3.jpg",
			},
			{
				name: "隆达公司集团营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz4.jpg",
			},
			{
				name: "知识产杈管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz5.jpg",
			},
			{
				name: "职业健康安全管理",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz6.jpg",
			},
			{
				name: "质量管理体系",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz7.jpg",
			},
			{
				name: "资质证书及延期证明",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldzz8.jpeg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "武城县县长质量奖提名奖",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldry1.jpg",
			},
			{
				name: "通风看声器",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldry2.jpg",
			},
			{
				name: "山东省 “专精特新”企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldry3.jpg",
			},
			{
				name: "高新技术企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldry2.jpg",
			},
			{
				name: "山东知名品牌",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldry3.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工控股集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldhb1.png",
				desc: "",
			},
			{
				name: "中国建筑集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldhb2.png",
				desc: "",
			},
			{
				name: "中冶建工集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldhb3.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 2,
				num: 2,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 2,
				num: 2,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "HTF消防排烟轴流风机", img: ldcp1 },
			{ name: "防爆型BHTF混流排烟风机", img: ldcp2 },
			{ name: "防火阀", img: ldcp3 },
		],
		navList: [
			{
				name: "HTF消防排烟轴流风机",
				isShow: false,
				id: 1,
				children: ["HTF消防排烟轴流风机"],
			},
			{
				name: "防爆型BHTF混流排烟风机",
				isShow: false,
				id: 2,
				children: ["防爆型BHTF混流排烟风机"],
			},
			{
				name: "防火阀",
				isShow: false,
				id: 3,
				children: ["防火阀"],
			},
		],
	},
    productDetailsData:	{
		HTF消防排烟轴流风机: {
			name: "HTF消防排烟轴流风机",
			img: ldcp1,
			modelNumber: [
				{
					title: "暂无",
					img: ldcp1,
				},
			],
			price: "1500",
			detailImgs: [ldcp1],
			modelNumberText: "HTF-I/II",
			brand: "圣隆达",
			describe:
				"消防风机主要是指当室内发生火灾的时候，会冒出很多的浓烟,它作用就是将这些浓烟排出室内。消防风机有一个排烟阀，排烟阀平时你都是关着的，当火灾发生的时候自动开启，它是与报警主机连着的，开启的条件是自动报警系统发生火警消防报警主机处于自动状态，消防排烟阀自动开启，联动消防排烟风机启动。",
			report: [ldbg1],
		},
		防爆型BHTF混流排烟风机: {
			name: "防爆型BHTF混流排烟风机",
			img: ldcp2,
			modelNumber: [
				{
					title: "暂无",
					img: ldcp2,
				},
			],
			price: "2000",
			detailImgs: [ldcp2],
			modelNumberText: "HTF-I/II",
			brand: "圣隆达",
			describe:
				"防爆混流排烟轴流风机是风机中的一种特殊类型，它是专业用在有易燃易爆的场所，最常用的行业为石油、化工等。它最主要的就是隔离风机启动、运行过程中，电机接线端子、定转子或其它部件产生的火花不与外界易燃易爆性的气体接触而引发安全事故的发生。",
			report: [ldbg2],
		},
		防火阀: {
			name: "防火阀",
			img: ldcp3,
			modelNumber: [
				{
					title: "暂无",
					img: ldcp3,
				},
			],
			price: "700",
			detailImgs: [ldcp3],
			modelNumberText: "FD",
			brand: "圣隆达",
			describe:
				"风阀常用分为：70℃、150℃、280℃安装在相应功能的管道上，平时处于常开状态，当温度达到相应温度是阀门关闭，起到隔烟阻火的作用。",
			report: [ldbg3],
		},
	},
    contactListData: {
		list: [
			{
				name: "尹志波",
				position: "集团副总(全国)",
				id: "2",
				phoneNum: "18888238000",
				telephone: "--",
				color: "#007DFF ",
				email: "sdzhipeng@163.com",
			},
			{
				name: "尹志朋",
				position: "董事长(全国)",
				id: "2",
				phoneNum: "13705345549",
				telephone: "--",
				color: "#23B095 ",
				email: "sdzhipeng@163.com",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "张家口冰雪运动装备产业园（冬奥会项目）",
				id: 1,
				price: "140万",
				time: "2020",
				site: "河北省张家口市",
				type: "产业园",
				unit: "河北鑫建邦消防工程有限公司",
				desc: "张家口冰雪运动装备产业园位于张家口高新技术产业开发区内，规划总面积1160亩，其中2018年8月首期开发示范区435亩，后期预留725亩。示范区总建筑面积为24.7万平方米，基建总投资11.42亿元人民币。主要分为：轻型装备生产区、重型装备制造区、办公研发综合服务区、冰雪运动展览中心等四大板块。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldgc1.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht1.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht2.png" },
				],
				product:
					"防爆防腐屋顶风机单层百叶排风及排烟口、高温消防排烟风机、280度防火阀、加压送风机、方形壁式轴流风机、HTF-II地下室排烟排风双速风机、板式排烟口、280℃防火阀、70℃防火阀、T35地下室楼梯加压送风机等",
			},

			{
				name: "青岛国际院士港二期项目",
				id: 2,
				price: "130万",
				time: "2019",
				site: "山东省青岛市",
				type: "产业园",
				unit: "北京维华普润暖通空调有限公司",
				desc: `青岛国际院士港，毗邻中国海洋大学，由26栋独体多层小楼和3栋高层组成，占地面积约88亩，建筑面积达19.6万平方米，是李沧区委、区政府坚持创新驱动和人才优先发展战略，打造院士聚集区。青岛国际院士港正式运作以来，开展了一系列卓有成效的院士引进工作。已接待36名海内外院士亲临园区参观考察，王玉田院士、周寿桓院士、袁隆平院士等7名院士已成功签订合作协议，5名院士项目正在重点推进中。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldgc2.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht3.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht4.png" },
				],
				product: "80℃常开排烟防火阀（与风机连锁）、70℃常开防火阀、电动对开多叶调节阀、排烟阀、对开多叶调节阀等",
			},

			{
				name: "红会医院高铁新城区",
				id: 3,
				price: "130万",
				time: "2021",
				site: "陕西省西安市",
				type: "医院",
				unit: "陕西建工第三建设集团有限公司",
				desc: `红会医院高铁新城院区由西安经发置业有限公司代建，项目位于秦汉大道与尚贤路交会处西北侧，总规划用地314亩，总建筑面积67.95万㎡，地上建筑面积41.87万㎡，地下建筑面积26.08万㎡，共设床位3000张。

				　　红会医院高铁新城院区是全市十三所重点医院建设项目中，建筑体量最大、床位最多、投资最高的一所医院，是一座“大综合、强骨科”现代化三级甲等综合医院。项目建成后将成为“西部领先、辐射周边、面向全国的高质量区域卫生健康中心”的主力军，对于进一步促进西安市医疗事业发展，优化区域医疗资源配套有着重要意义。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldgc3.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht5.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dzld/ldht6.png" },
				],
				product:
					"HTFC-II离心式双速排烟风机箱、止回阀、280°排烟防火阀、消声静压箱、对开多叶调节阀、单层百叶风口（带调节阀）、塑料型吸顶式换气扇,中档、70℃防火阀、不锈钢风帽、SWF混流风机、HTF-II消防高温双速排烟轴流风机、电动密闭阀、双层百叶风口等。",
			},
		],
	},
    evaluationData:{
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 1,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],

		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: true,
			},
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "中化二建集团有限公司-陕煤集团榆林化学180万吨/年乙二醇工程草酸二甲酯装置-通风工程劳务分包",
				name2: "中化二建集团有限公司-陕煤集团榆林化学180万吨/年乙二醇工程草酸二甲酯装置-通风工程劳务分包",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "隆尧县医院建设项目人防工程暖通材料（暂估价部分）采购和伴随服务采购 ",
				name2: "隆尧县医院建设项目人防工程暖通材料（暂估价部分）采购和伴随服务采购  ",
				name3: "物资采购",
				date: "2022/8/24",
			},
			{
				name1: "隆尧县医院传染病病区暖通空调设备材料（暂估价部分）采购和伴随服务项目",
				name2: "隆尧县医院传染病病区暖通空调设备材料（暂估价部分）采购和伴随服务项目",
				name3: "物资采购",
				date: "2022/7/15",
			},
			{
				name1: "隆尧县医院建设项目人防工程给排水设备材料（暂估价部分）采购和伴随服务项目",
				name2: "隆尧县医院建设项目人防工程给排水设备材料（暂估价部分）采购和伴随服务项目",
				name3: "物资采购",
				date: "2022/6/15",
			},
			{
				name1: "中化二建集团有限公司内蒙古分公司陕煤榆林化学东华乙二醇项目风管材料公开询比价",
				name2: " 中化二建集团有限公司内蒙古分公司陕煤榆林化学东华乙二醇项目风管材料公开询比价",
				name3: "物资采购",
				date: "2022/1/12",
			},

			{
				name1: "隆尧县医院建设项目教学楼、后勤用房工程—教学楼后勤用房暖通设备（材料暂估价部分）采购和伴随服务采购项目",
				name2: "隆尧县医院建设项目教学楼、后勤用房工程—教学楼后勤用房暖通设备（材料暂估价部分）采购和伴随服务采购项目",
				name3: "物资采购",
				date: "--",
			},
			{
				"企业名称": "德州隆达空调设备集团有限公司",
				"name1": "陕三建-设备安装公司-蓝田山水华府项目风口风阀采购合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "蓝田山水华府项目（机电安装）",
				"name3": "物资采购",
				"date": "2023年1月17日",
				"out": true
			},
			{
				"企业名称": "德州隆达空调设备集团有限公司",
				"name1": "新增通风专业分包合同",
				"name4": "陕西建工第二建设集团有限公司",
				"name2": "安-沣西新城创新港幼儿园、小学项目",
				"name3": "专业分包",
				"date": "2022年11月18日",
				"out": true
			}
		],
	},
    lawData: 	{
		info: [
			{
				caseName: "德州隆达空调设备有限公司、杨泽刚加工合同纠纷民事一审民事裁定书",
				// 案号
				reference: "（2021）鲁1428民初2324号",
				// 案由
				cause: "加工合同纠纷",
				//身份
				identity: "原告",
				//类型
				caseType: "民事案件",

				date: "2022-04-07",
			},
		],
	},
    tipData:	{
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立5年以上",
			},
		],
	},
}